/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var UIUtil = require('psa-core/util/ui');
var userHasRole = require('common/util/userHasRole');

var SideNavSectionView = require('common/views/SideNavSectionView');
var BreadcrumbView = require('common/views/BreadcrumbView');
var DropdownView = require('common/views/DropdownView');
var ConfirmationModalView = require('common/views/ConfirmationModalView');
var ContentServerLinkView = require('common/views/ContentServerLinkView');

var CorpFinRecordHeaderBarView = require('../../common/views/CorpFinRecordHeaderBarView');
var SubmitRecord = require('../../common/services/SubmitRecord');
var CorpFinInvInvestmentSectionView = require('./CorpFinInvInvestmentSectionView');

var tmplCorpFinInvestmentDashboardView = require('../templates/CorpFinInvestmentDashboardView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCorpFinInvestmentDashboardView,

  className: 'corp-fin-investment-dashboard-view container-fluid m-b-lg',

  ui: {
    investmentWrapper: '.investment-wrapper',
    csLinkContainer: '.cs-link-container',
    invActionDropDown: '.dropdown-container',
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container'
  },

  regions: {
    investmentWrapper: '@ui.investmentWrapper',
    csLinkContainer: '@ui.csLinkContainer',
    invActionDropDown: '@ui.invActionDropDown',
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb'
  },

  onBeforeShow: function() {
    var recordId = this.model.get('recordId');
    var record = this.model.get('record') || {};
    var recordCategoryId = record.recordCategoryId;
    var fileNumber = record.fileNumber;
    var isReadOnly = userHasRole('CF - Read Only');

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#corpfin/dashboard',
            text: 'Home'
          },
          {
            text: 'Investment (' + fileNumber + ')'
          }
        ]
      })
    );

    if (!isReadOnly) {
      var dropDownOptions = [
        {
          text: 'Edit Investment',
          link: '#corpfin/investment/' + recordId + '/edit-details'
        },
        {
          text: 'Delete Investment',
          onClick: this.onClickDelete.bind(this)
        },
        {
          isDivider: true
        },
        {
          text: 'Add Investment History',
          link: '#corpfin/investment/' + recordId + '/new-investment-history'
        },
        {
          text: 'Add Fee',
          link: '#corpfin/investment/' + recordId + '/new-fee'
        },
        {
          text: 'Add Portfolios',
          link: '#corpfin/investment/' + recordId + '/new-portfolio'
        }
      ];
    }

    this.showChildView(
      'invActionDropDown',
      new DropdownView({
        rightAlign: true,
        model: new Backbone.Model({
          name: 'Investment Actions',
          options: dropDownOptions
        })
      })
    );

    this.showChildView(
      'csLinkContainer',
      new ContentServerLinkView({
        model: new Backbone.Model({
          buttonText: 'Open Investment Folder',
          contentServerId: record.recordCSFolderId
        })
      })
    );

    this.showChildView(
      'headerBar',
      new CorpFinRecordHeaderBarView({
        model: new Backbone.Model(record)
      })
    );

    this.investment = new SideNavSectionView({
      collection: new Backbone.Collection([
        {
          id: 'investment',
          title: 'Investment',
          view: new CorpFinInvInvestmentSectionView({
            model: new Backbone.Model(record)
          })
        },
        {
          id: 'investmentHistory',
          title: 'Investment History',
          view: Radio.channel('cf').request('build:corp-fin-inv-history-section-view', recordId, isReadOnly)
        },
        {
          id: 'fee',
          title: 'Fee',
          view: Radio.channel('cf').request('build:corp-fin-fees-section-view', recordId, recordCategoryId, isReadOnly)
        },
        {
          id: 'portfolios',
          title: 'Portfolios',
          view: Radio.channel('cf').request('build:corp-fin-inv-portfolio-section-view', recordId, isReadOnly)
        },
        {
          id: 'priorNames',
          title: 'Prior Names',
          view: Radio.channel('cf').request(
            'build:corp-fin-prior-names-section-view',
            recordId,
            recordCategoryId,
            isReadOnly
          )
        },
        {
          id: 'notes',
          title: 'Notes',
          view: Radio.channel('cf').request('build:notes-view', {
            objectId: recordId,
            objectTypeId: 'INVESTMENT'
          })
        },
        {
          id: 'auditLog',
          title: 'Audit Log',
          view: Radio.channel('cf').request('build:audit-log-view', {
            objectId: recordId,
            objectTypeId: 'INVESTMENT'
          })
        }
      ])
    });
    this.showChildView('investmentWrapper', this.investment);
  },

  onClickDelete: function() {
    var self = this;
    var message = 'Are you sure you want to delete this investment?';
    UIUtil.showModal({
      title: 'Confirm Deleting Investment',
      view: new ConfirmationModalView({
        confirmText: 'Delete Investment',
        model: new Backbone.Model({
          message: message,
          onConfirm: function() {
            var recordId = self.model.get('recordId');
            return SubmitRecord({ recordId: recordId, isDeleted: '1' });
          },
          onConfirmDone: function() {
            Radio.channel('navigate').trigger('show:int:cf:dashboard');
          }
        })
      })
    });
  }
});
